import { makeStyles } from '@material-ui/styles'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import EllipsisText from 'k8s/components/common/EllipsisText'
import React from 'react'

type RowInfoProps = {
  label: string
  value: string
  minWidth?: number
  isCompact?: boolean
}

const useStyles = makeStyles<Theme, { minWidth?: number }>(() => ({
  row: {
    display: 'flex',
  },
  headerContainer: {
    minWidth: ({ minWidth }) => minWidth ?? 80,
  },
}))

const RowInfo: React.FC<RowInfoProps> = ({ label, value, minWidth, isCompact = false }) => {
  const classes = useStyles({ minWidth })

  return (
    <div className={classes.row}>
      <div className={classes.headerContainer}>
        <Text variant="body2">{label}:</Text>
      </div>
      {isCompact ? (
        <EllipsisText
          title={value}
          showTooltip={true}
          maxWidth={isCompact ? 120 : undefined}
          variant="subtitle2"
        >
          {value}
        </EllipsisText>
      ) : (
        <Text variant="caption1">{value}</Text>
      )}
    </div>
  )
}

export default RowInfo
